import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { Column, ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
})



export class CustomTooltipComponent implements ITooltipAngularComp, AfterViewInit {
  @ViewChild('tooltipText') tooltipTextRef!: ElementRef;
  params!: ITooltipParams;
  shouldShow = true;

  constructor(private cdr: ChangeDetectorRef){

  }

  agInit(params: ITooltipParams): void {
    this.params = params;
  }

  ngAfterViewInit(): void {
      if (this.params.column && !(this.params.column as any).isGroup) {
        const column = this.params.column as Column;
        const colId = column.getColId();
        const rowIndex =this.params.rowIndex;
        const selector = `.ag-row[row-index="${rowIndex}"][row-id="${rowIndex}"] .ag-cell[col-id="${colId}"]`;
        const cellEl = document.querySelector(selector) as HTMLElement;
          if (cellEl) {
            const span = cellEl.querySelector('span') || cellEl;
            this.shouldShow = span.scrollWidth > span.clientWidth;
          }
      }
      this.cdr.detectChanges();
  }
}
